'use client';

import './energy-utilities.css';
import { useEffect } from 'react';

const iconProps = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };



function IconUsers() {
  return (
    <svg {...iconProps}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M15.5 14a5 5 0 0 1 5.5 5" />
    </svg>
  );
}

function IconGlobe() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.5 4 6 4 9s-1.5 6.5-4 9c-2.5-2.5-4-6-4-9s1.5-6.5 4-9z" />
    </svg>
  );
}

function IconGear() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    </svg>
  );
}

function IconHandshake() {
  return (
    <svg {...iconProps}>
      <path d="M2 12l5-4 4 3 3-3 8 4" />
      <path d="M6 15l3 3 3-2 3 3 3-3 2 2" />
    </svg>
  );
}

function IconChartUp() {
  return (
    <svg {...iconProps}>
      <path d="M4 20V10M12 20V4M20 20v-7" />
    </svg>
  );
}

const industries = [
  {
    slug: 'energy-utilities',
    href: '/industries/energy-utilities',
    name: 'Energy & Utilities',
    image: '/assets/images/energy1.png',
    desc: 'Powering progress. Smarter, more sustainable utilities.',
  },
  {
    slug: 'fmcg-retail',
    href: '/industries/fmcg-retail',
    name: 'FMCG & Retail',
    image: '/assets/images/energy2.png',
    desc: 'Stronger brands. Smarter supply chains. Happier consumers.',
  },
  {
    slug: 'manufacturing',
    href: '/industries/manufacturing',
    name: 'Manufacturing',
    image: '/assets/images/energy3.png',
    desc: 'Efficient operations. Higher productivity. Future-ready factories.',
  },
  {
    slug: 'life-sciences',
    href: '/industries/pharma-lifescience',
    name: 'Life Sciences',
    image: '/assets/images/enrgy4.png',
    desc: 'Better medicines. Higher compliance. Healthier lives.',
  },
  {
    slug: 'bfsi',
    href: '/industries/bfsi',
    name: 'BFSI',
    image: '/assets/images/energy6.png',
    desc: 'Insightful decisions. Greater resilience. Trusted growth.',
  },
  {
    slug: 'airlines-travel',
    href: '/industries/airlines-airports',
    name: 'Airlines & Travel',
    image: '/assets/images/energy5.png',
    desc: 'Safer operations. Seamless journeys. Exceptional experiences.',
  },
  {
    slug: 'professional-services',
    href: '/industries/professional-services',
    name: 'Professional Services',
    image: '/assets/images/ProfessionalServices.png',
    desc: 'People with purpose. Projects with impact. Growth without limits.',
  },
];

const stats = [
  [IconUsers, '300+', 'Minds'],
  [IconGlobe, '6', 'Regions'],
  [IconGear, '7', 'Industry Verticals'],
  [IconHandshake, '500+', 'Projects Delivered'],
  [IconChartUp, 'Real', 'Business Outcomes'],
];

export default function EnergyUtilitiesPage() {
    useEffect(() => {
    const elements = document.querySelectorAll('.eu-scroll-reveal');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="eu-page">
      <section
        className="eu-hero"
        style={{ backgroundImage: 'url(/assets/images/utilities.png)' }}
      >
       <div className="eu-hero-copy eu-scroll-reveal">
         
          <h1>Make every<br />decision count.</h1>
          <p>From complex operations to better outcomes — we help enterprises transform, improve and operate with confidence.</p>
          <div className="eu-hero-buttons">
            <a href="/tellusyourproblem#tell-details" className="eu-btn-primary">Tell us your problem <span>→</span></a>
            <a href="/industries" className="eu-btn-link">Explore our industries <span className="play-icon">▶</span></a>
          </div>
        </div>

        <div className="eu-hero-tag">
          <span className="eu-hero-tag-label">ENERGY &amp; UTILITIES</span>
          <p>Reliable operations.<br />Sustainable growth.<br />A better tomorrow.</p>
        </div>
      </section>

      <h2 className="eu-section-heading eu-scroll-reveal">Expertise Across Industries. Impact Beyond Expectations.</h2>

      <section className="eu-industry-grid">
        {industries.map((ind) => (
          <a
            href={ind.href}
            className="eu-industry-card"
            key={ind.slug}
            style={{ backgroundImage: `url("${encodeURI(ind.image)}")` }}
          >
            <span className="eu-card-label">{ind.name}</span>
            <div className="eu-card-reveal">
              <p>{ind.desc}</p>
              <span className="eu-card-arrow">→</span>
            </div>
          </a>
        ))}
      </section>

      <section className="eu-stats">
        <div className="eu-stats-row">
          {stats.map(([Icon, value, label]) => (
            <div className="eu-stat" key={label}>
              <span className="eu-stat-icon"><Icon /></span>
              <div>
                <strong>{value}</strong>
                <span>{label}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="eu-stats-note">
          <p>Enterprise Expertise.<br />Applied Intelligence. Real Impact.</p>
        </div>
      </section>

      <section
        className="eu-region-bar"
        style={{ backgroundImage: 'url(/assets/images/ctaenergy.png)' }}
      >
        <span className="eu-region-list">INDIA &nbsp;|&nbsp; AFRICA &nbsp;|&nbsp; MIDDLE EAST &nbsp;|&nbsp; GLOBAL</span>
        <span className="eu-region-tagline">A MORE VALUABLE TOMORROW. TOGETHER.</span>
      </section>
    </main>
  );
}
